import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useFormContext } from "./formElements";

export default function OptionalCheckbox({ value }) {
  const element = value;
  const { onChange } = useFormContext();

  const handleChangeLabel = (event) => {
    element.label = event.target.value;
    onChange({ ...element });
  };

  const handleChangeValue = (event) => {
    element.value = event.target.value;
    onChange({ ...element });
  };

  const handleChangeChecked = (event) => {
    element.checked = event.target.checked;
    onChange({ ...element });
  };

  return (
    <div className={"mb-2"}>
      <InputGroup>
        <Form.Control
          value={element.label ?? ""}
          onChange={handleChangeLabel}
          className={"bg-light"}
          style={{ maxWidth: "280px" }}
        />
        <Form.Control
          value={element.value ?? ""}
          onChange={handleChangeValue}
          placeholder={"wartość"}
        />
        <InputGroup.Text>
          <Form.Check
            type={"checkbox"}
            checked={!!element.checked}
            onChange={handleChangeChecked}
            className={"m-0"}
          />
        </InputGroup.Text>
      </InputGroup>
    </div>
  );
}
